// src/components/BackButton.jsx
import React from 'react';
import styled from 'styled-components';

// Define styles first
const StyledButton = styled.button`
  background-color: ${props => props.enabled ? '#025dc7' : 'grey'};
  cursor: ${props => props.enabled ? 'pointer' : 'not-allowed'};
  border: none;
  border-radius: 25px;
  color: white;
  display: flex;
  align-items: center;
  padding: 0px 20px;
  font-size: 12px;

  img {
    margin-left: 10px;
  }

  @media only screen and (max-width: 700px) {
    font-size: 10px;
    height: 22px !important;
    padding: 0px 10px;
    img {
      height: 17px;
      margin-left: 5px;
    }
  }
`;

// Then use it here
const BackButton = ({ enabled = true, onClick }) => (
  <StyledButton
    enabled={enabled}
    disabled={!enabled}
    onClick={enabled ? onClick : undefined}
  >
    ← Back
  </StyledButton>
);

export default BackButton;
